import { useCallback } from 'react';
import { getTimeOffSyncRun, listTimeOffSyncRuns } from '../../../api/timeOff';
import { SyncRunsGrid } from '../../Admin/SyncJobs/components/SyncRunsGrid';

export function TimeOffSyncLogsPage() {
  const loadPage = useCallback(
    (request: Parameters<typeof listTimeOffSyncRuns>[0]) => listTimeOffSyncRuns(request),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <SyncRunsGrid
          loadPage={loadPage}
          loadDetails={getTimeOffSyncRun}
          showJobName={false}
          stateStorageKey="webopsui:time-off-sync-runs-grid"
        />
      </div>
    </div>
  );
}
